import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnchorEPIMsService } from './services/anchorepimsgates.service';
import { EffectsModule } from '@ngrx/effects';
import { AnchorEPIMSEffects } from './states/+anchorepimsgates/anchorepimsgates.effects';
import { AnchorEPIMSFacade } from './states/+anchorepimsgates/anchorepimsgates.facade';
import { StoreModule } from '@ngrx/store';

import * as epimsgatereducer from './states/+anchorepimsgates/anchorepimsgates.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      epimsgatereducer.EpimsGate_FEATURE_KEY,
      epimsgatereducer.engagementreducer,
    ),

    StoreModule.forFeature(
      'language0001',
      epimsgatereducer.languagereducer,
    ),
    StoreModule.forFeature(
      epimsgatereducer.EpimsGate_FEATURE_KEY_Document,
      epimsgatereducer.documentreducer,
    ),
   
  
    EffectsModule.forFeature([AnchorEPIMSEffects])],
    providers: [AnchorEPIMSFacade],
  

})
export class AnchorepimsgatesModule {}
